import { PrioritizationWorkflowComponent } from "@cimpress-technology/scraping-jobs";
import React from "react";
import { Link, useParams } from "react-router-dom";

import Breadcrumb from "./breadcrumb/Breadcrumb";
import { workFlowItems } from "./breadcrumb/breadcrumbElements";

const Workflow = props => {
  const {id} = useParams();

  return (
    <div className="container-fluid">
      <div style={{ paddingLeft: '15px' }}>
        <Breadcrumb separator="/">
          {workFlowItems.map(({ to, label }) => (
            <Link key={to} to={to}>
              {label}
            </Link>
          ))}
        </Breadcrumb>
      </div>
      <div className="container-fluid">
        <PrioritizationWorkflowComponent
            accessToken={props.accessToken}
            isProduction={props.isProduction}
            accountId={id}
        />
      </div>
    </div>
  );
};

export default Workflow;
